import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { MultiValue, SingleValue } from 'react-select';

import { InputOptionsWithIcon } from 'components/common/MyCustomSelect/components/InputOptionsWithIcon/InputOptionsWithIcon';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';
import { OptionType } from 'components/DesignSystem/Select/Select';

export const Status = ({ options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Status</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        id={'battlecards-filters-status'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isMulti
                        options={options}
                        isClearable={true}
                        components={{
                            Option: InputOptionsWithIcon,
                        }}
                        isLoading={isLoading}
                    />
                )}
                name={`status`}
                control={control}
            />
        </div>
    );
};
